<script>
export default {
  props: {
    dictionary: {
      type: Object,
      required: true,
    },
    showExpressAndBox: {
      type: Boolean,
      default: false,
    },
  }
}
</script>

<template>
  <div class="xmasBanner">
    <div class="xmasBanner__guarantee">
      <img :src="`/nuxt-assets/icons/white-tree.svg`" alt="tree" width="12" />
      <span>{{ dictionary.guarantee.default }} <a :href="dictionary.guarantee.defaultLink" target="_blank">{{ dictionary.guarantee.defaultLinkText }}</a></span>
    </div>
    <div v-if="showExpressAndBox" class="xmasBanner__pilulka-express">
      <img :src="`/nuxt-assets/icons/white-point.svg`" alt="tree" width="12" />
      <span class="xmasBanner__pilulka-express-header">{{ dictionary.guarantee.pilulkaExpress }}</span> → <span>{{ dictionary.guarantee.pilulkaExpressDate }}</span>
    </div>
    <div v-if="showExpressAndBox" class="xmasBanner__pilulka-box">
      <img :src="`/nuxt-assets/icons/white-point.svg`" alt="tree" width="12" />
      <span class="xmasBanner__pilulka-express-header">{{ dictionary.guarantee.pilulkaBox }}</span> → <span>{{ dictionary.guarantee.pilulkaBoxDate }}</span>
    </div>
  </div>
</template>
